module.exports = __webpack_public_path__ + "static/pitpaylogoorangeline-9f30ff0ea999bf26f52f13b5e3009405.png";